import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, processError } from "../../../core/helpers/service-helper";


export const listarEntidadesPension = () => {
    return axios.get(`${API_URL}/administrar/entidadesPension`, {
        headers: getHeaders(),
    });
};

export const crearOEditarEntidadPension = async (entidadPension) => {
    try {
        if (entidadPension.id) {
            const resp = await axios.put(
                `${API_URL}/administrar/entidadesPension/${entidadPension.id}`,
                entidadPension,
                { headers: getHeaders() }
            );

            return resp.data;
        }

        const resp = await axios.post(
            `${API_URL}/administrar/entidadesPension`,
            entidadPension,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const inactivarEntidadPension = async (id_entidad_pension) => {
    try {
        const resp = await axios.delete(
            `${API_URL}/administrar/entidadesPension/${id_entidad_pension}`,
            {
                headers: getHeaders(),
            }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const activarEntidadPension = async (data) => {
    try {
        const resp = await axios.post(
            `${API_URL}/administrar/entidadesPension/activar/${data.id}`,
            data,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};
